// extracted by mini-css-extract-plugin
export var typingIndicator = "_mt-0";